/*
* User common utilities & components
*/

import * as _ from 'lodash';

export const MinimumPasswordLength: number = 4;
export const MinimumAssignedRoles: number = 1;
export const MinimumAssignedRegions: number = 1;

// HELPER FUNCTIONS
export const IsDuplicateUsername = (username: string, users: Array<any>) => {
    return (_.find(users, (o) => _.toLower(username) === _.toLower(_.get(o, 'username', '')))) ? true : false;
};

export const IsDuplicateEmail = (email: string, users: Array<any>) => {
    return (_.find(users, (o) => _.toLower(email) === _.toLower(_.get(o, 'email', '')))) ? true : false;
};

export const IsPasswordValid = (password: string) => {
    const passwordLen = _.size(password);
    const passwordInvalid = (passwordLen < MinimumPasswordLength) ? true : false;

    return !(passwordInvalid);
};

export const DoPasswordsMatch = (newPassword: string, newPasswordConfirm: string) => {
    const passwordLen = _.size(newPassword);
    const passwordConfirmLen = _.size(newPasswordConfirm);

    const passwordsMismatched = (
        (passwordLen || passwordConfirmLen) &&
        (newPassword !== newPasswordConfirm)) ? true : false;

    return !passwordsMismatched;
};

export const AreAssignedRolesValid = (assigned: Array<any>) => {
    const assignedLen = _.size(assigned);
    const assignedInvalid = (assignedLen < MinimumAssignedRoles) ? true : false;

    return !(assignedInvalid);
};

export const AreAssignedRegionsValid = (assigned: Array<any>) => {
    const assignedLen = _.size(assigned);
    const assignedInvalid = (assignedLen < MinimumAssignedRegions) ? true : false;

    return !(assignedInvalid);
};

export const GetAssignedRoles = (userRoleOptions: Array<any>) => {
    if (!userRoleOptions) { return []; }

    return _.filter(userRoleOptions, ['assigned', true ]);
};

export const HasAssignedRole = (roleName: string, userRoleOptions: Array<any>): boolean => {
    let result = false; 
    if (!roleName || !_.size(userRoleOptions)) { return false; }

    const assignedRoles = _.filter(userRoleOptions, ['assigned', true ]);

    const hasRole = _.find(assignedRoles, ['text', roleName]);
    
    result = (hasRole) ? true : false;

    // console.log(`HasAssignedRole roleName ${roleName} result ${result}`, { assignedRoles: assignedRoles });

    return result;
};

export const GetAssignedRegions = (userRegionOptions: Array<any>) => {
    if (!userRegionOptions) { return []; }

    return _.filter(userRegionOptions, ['assigned', true ]);
};

export const GetAssignedGroups = (userGroupOptions: Array<any>) => {
    if (!userGroupOptions) { return []; }

    return _.filter(userGroupOptions, ['assigned', true ]);
};

export const GetUserInventoryTemplates = (userInventoryTemplates: Array<any>) => {
    if (!userInventoryTemplates) { return []; }
    // return _.filter(userInventoryTemplates, ['name', true ]);
    const result = _.cloneDeep(userInventoryTemplates);

    // console.log(`user-components.tsx::GetUserInventoryTemplates userInventoryTemplates.len ${_.size(userInventoryTemplates)} result.len ${_.size(result)}`, { userInventoryTemplates, result });

    return result;
};



// WEBPACK FOOTER //
// ./src/common/user-components.tsx